export default "__VITE_ASSET__DIooJYq$__"